export default __webpack_public_path__ + "static/media/iMac Pro Right Side View Mockup.ea0380ff.png";